import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useImpoundAnalysisForm = (
  onSubmit,
  values,
  startingInvoice,
  loanCushion
) => {
  const fields = useMemo(
    () => [
      {
        title: 'Impound Analysis',
        isTitleHidden: false,
        fields: [
          {
            title: 'Starting Invoice',
            name: 'startingInvoice',
            type: 'date',
            readOnly: true,
            tooltip: `${startingInvoice?.sequence} - ${startingInvoice?.pixel_invoice_number} is the first pending invoice available.`,
          },
          {
            title: 'Initial Impound Balance',
            name: 'initialImpoundBalance',
            type: 'currency',
            readOnly: true,
            tooltip:
              'The balance carried over from the invoice prior to the starting invoice.',
            tooltipSize: 'lg',
          },
          {
            title: 'Total Monthly Impound Payment',
            name: 'totalMonthlyImpoundPayment',
            type: 'currency',
            readOnly: true,
            tooltip:
              'The total of distributions in the 12 months following the starting invoice.',
            tooltipSize: 'lg',
          },
          {
            title: 'Tax Payment',
            name: 'taxPayment',
            type: 'currency',
            readOnly: true,
          },
          {
            title: 'Insurance Payment',
            name: 'insurancePayment',
            type: 'currency',
            readOnly: true,
          },
          {
            title: 'HOA Payment',
            name: 'hoaPayment',
            type: 'currency',
            readOnly: true,
          },
          {
            title: 'Total Cushion',
            name: 'totalCushion',
            type: 'currency',
            readOnly: true,
            tooltip: `Loan is configured for a ${loanCushion} month cushion.`,
            tooltipSize: 'lg',
          },
          {
            title: 'Adjustment',
            name: 'adjustment',
            type: 'currency',
            readOnly: true,
            tooltip:
              'The total cushion minus the lowest value in the calculated balance column.',
            tooltipSize: 'lg',
          },
        ],
      },
    ],
    [
      loanCushion,
      startingInvoice?.pixel_invoice_number,
      startingInvoice?.sequence,
    ]
  );

  return useForm({ fields, onSubmit, values });
};

export default useImpoundAnalysisForm;
